
<div :id="ariaDescribedByName" class="mt-8 flex relative items-center" :class="customClasses" tabindex="-1">
  <div class="mr-4 self-start">
    <slot name="customIcon" />
    <warning-outline-icon v-if="showErrorIcon" id="error-icon" :color="errorIconColor" :height="16" :width="16" />
    <tick-circle-outline-icon v-if="showSuccessIcon" id="success-icon" color="#229150" :height="16" :width="16" />
  </div>
  <p :class="['text-field-helper', textfieldHelperClasses]" aria-live="assertive" v-html="text" />
</div>
